

export const backendUrl: string = 'https://hackathon-api.digitalberd.com'
// export const backendUrl: string = 'http://localhost:8004'
export const siteOrigin: string = backendUrl

export const GA_ID = 'G-PJLLXY521Q'

